export { IconLabel } from "./icon-label";
